/* Knobs.co — Cabinet Hardware Wizard results renderer (task #5).
   ─────────────────────────────────────────────────────────────────
   Reads quiz answers from URL params, composes a native legacy tag-URL
   query against /collections/all, fetches the JSON feed
   (templates/collection.wizard-feed.liquid via ?view=wizard-feed),
   filters by type/drill/speed client-side, collapses same-model-
   different-finish families via a ported knobs-sku-root rule, and renders
   a curated grid of real product matches.

   Why this shape:
     - Legacy tag-URL filtering (/collections/all/style-x+finish-y) filters
       server-side without depending on Search & Discovery config.
     - The feed carries the custom.delivery_days metafield (Q5) and full tags
       (drill + family dedup) that /products.json can't provide.
     - Collection-page Liquid dedup is PARKED, so the wizard owns its dedup.

   Created: 2026-05-30 (task #5). Email capture → Klaviyo profile is wired
   minimally here; task #6 expands it (events, tags, full property set).
*/
(function () {
  'use strict';

  var root = document.getElementById('knobs-wizard-results');
  if (!root) return;

  var loadingEl = root.querySelector('[data-loading]');
  var gridEl = root.querySelector('[data-results-grid]');
  var headingEl = root.querySelector('[data-results-heading]');
  var narrativeEl = root.querySelector('[data-results-narrative]');
  var refineEl = root.querySelector('[data-refine]');
  var broadenLink = root.querySelector('[data-broaden]');
  var consultCtaEl = root.querySelector('[data-consultation-cta]');
  var tradeBannerEl = root.querySelector('[data-trade-banner]');
  var samplesCtaEl = root.querySelector('[data-samples-cta]');
  var quoteCtaEl = root.querySelector('[data-quote-cta]');
  var emailCaptureEl = root.querySelector('[data-email-capture]');
  var emailForm = root.querySelector('[data-email-form]');
  var consultLink = root.querySelector('[data-consultation-link]');
  var consultHeadingEl = root.querySelector('[data-consult-heading]');
  var consultBodyEl = root.querySelector('[data-consult-body]');
  var suggestedEl = root.querySelector('[data-suggested]');
  var suggestedChipsEl = root.querySelector('[data-suggested-chips]');
  var finishRefineEl = root.querySelector('[data-finish-refine]');
  var otherStylesEl = root.querySelector('[data-other-styles]');
  var otherTitleEl = root.querySelector('[data-other-title]');
  var otherGridEl = root.querySelector('[data-other-grid]');

  var consultationUrl = root.getAttribute('data-consultation-url') || '/pages/consultation';
  var wizardUrl = root.getAttribute('data-wizard-url') || '/pages/wizard';

  var TARGET = 12;        // families to show
  var PER_PAGE = 60;      // matches the feed template's paginate size
  var MAX_PAGES = 8;      // safety cap on fetching (≤480 candidate products;
                          // visual-family merging collapses size runs, so we
                          // need a deeper pool than the sku-root dedup did)

  /* ── Vocabulary maps (mirror the Question Tree v1 spec) ─────────── */
  var STYLE_TAG = {
    'modern-contemporary': ['style-modern', 'style-contemporary'],
    'transitional': ['style-transitional'],
    'traditional': ['style-traditional']
  };
  var FINISH_TAG = {
    nickel:'finish-class-nickel', black:'finish-class-black', bronze:'finish-class-bronze',
    brass:'finish-class-brass', chrome:'finish-class-chrome', gold:'finish-class-gold',
    iron:'finish-class-iron', copper:'finish-class-copper', pewter:'finish-class-pewter',
    gray:'finish-class-gray', steel:'finish-class-steel', brown:'finish-class-brown',
    clear:'finish-class-clear', aluminum:'finish-class-aluminum', silver:'finish-class-silver',
    white:'finish-class-white', colored:'finish-class-colored'
  };
  var STYLE_LABEL = { 'modern-contemporary':'Modern / Contemporary', transitional:'Transitional', traditional:'Traditional' };
  var TYPE_LABEL = { knobs:'Knobs', pulls:'Pulls', 'appliance-pulls':'Appliance Pulls', hinges:'Hinges', backplates:'Backplates', accessories:'Accessories', other:'Hardware' };

  // Sparse, single-product-type buckets get their own dense per-type collection
  // (so we don't scrape them thin out of /collections/all). Abundant buckets
  // (knobs, pulls) source from /collections/all so sub-types (round knobs, bar
  // pulls, etc.) are all included and filtered client-side by product_type.
  var NARROW_COLLECTION = {
    'appliance-pulls': 'product-type-cabinet-hardware-appliance-pulls',
    'hinges': 'product-type-cabinet-hardware-hinges',
    'backplates': 'product-type-cabinet-hardware-backplates',
    'accessories': 'product-type-cabinet-hardware-catches-and-latches'
  };
  // Choose source collection handle(s) from the selected types.
  function sourceCollections(types) {
    if (types.length && types.every(function (t) { return NARROW_COLLECTION[t]; })) {
      var seen = {}, out = [];
      types.forEach(function (t) { var h = NARROW_COLLECTION[t]; if (!seen[h]) { seen[h] = 1; out.push(h); } });
      return out;
    }
    return ['all'];
  }

  // Made-to-order vendors (from sections/knobs-product.liquid lead-time cases).
  var MTO_VENDORS = {
    'Carpe Diem Hardware':1, 'Notting Hill':1, 'Sietto':1, 'Anne at Home':1,
    'Edgar Berebi':1, 'Edgar Berebi-Urban Metro':1, 'Jaye Design':1,
    'Aquila Art Glass':1, 'Rocky Mountain Hardware':1, 'Rocky Mountain':1
  };

  function readAnswers() {
    var p = new URLSearchParams(window.location.search);
    return {
      types: (p.get('types') || '').split(',').filter(Boolean),
      style: p.get('style') || '',
      finish: p.get('finish') || '',
      drill: p.get('drill') || '',
      speed: p.get('speed') || '',
      interests: (p.get('interests') || '').split(',').filter(Boolean),  // multi-select intent
      // trade comes from the home-vs-business question (drives the Trade Pros PROGRAM
      // invite) — distinct from the "quote for a large order" checkbox.
      trade: p.get('trade') === 'trade' ? 'trade' : '',
      budget: p.get('budget') || '',                // relative price tier (per category)
      finishSpecific: p.get('fin_spec') || ''       // second-layer specific-finish refine
    };
  }

  /* ── GA4 funnel events (knobs-wizard-track.js); no-op if absent ─── */
  function track(name, params) {
    if (typeof window.KWTrack === 'function') window.KWTrack(name, params);
  }
  function answersFlat(a) {
    return {
      types: a.types.join(','), style: a.style, finish: a.finish,
      drill: a.drill, speed: a.speed, budget: a.budget,
      interests: (a.interests || []).join(','), trade: a.trade === 'trade' ? 'trade' : 'home'
    };
  }

  /* ── Completion telemetry → team email ─────────────────────────────
     One email per genuine completion. This script only CREATES the journey
     record (answers + actions with seconds-since-completion timestamps) in
     localStorage; the site-wide knobs-journey.js follows the visitor for the
     rest of their visit (page views, add-to-carts, checkout start, CTA clicks)
     and beacons the summary to the knobs-trade-apply worker → Resend relay
     when they leave the site, start checkout, or hit the 45-min cap.
     Guards: only when THIS browser just ran the wizard (localStorage progress
     exists — shared/revisited URLs stay silent) and the same answer-set
     doesn't re-notify for 6h (refreshes, back-button). Failures are silent. */
  var kwJourneyTs = null;
  var kwResultCount = null;
  function journeyUpdate(fn) {
    try {
      var j = JSON.parse(localStorage.getItem('kw.journey.v2') || 'null');
      if (!j || j.sent) return;
      fn(j);
      localStorage.setItem('kw.journey.v2', JSON.stringify(j));
    } catch (e) {}
  }
  function recordAction(cta, item) {
    var label = item ? cta + ': ' + item : cta;
    journeyUpdate(function (j) {
      if (Array.isArray(j.actions) && j.actions.length < 30) {
        j.actions.push({ t: Math.max(0, Math.round((Date.now() - j.ts) / 1000)), a: label.slice(0, 120) });
      }
    });
    track('wizard_cta_click', { cta: cta, item: (item || '').slice(0, 100) });
  }
  function initCompletionNotify(a) {
    var prog = null;
    try { prog = JSON.parse(localStorage.getItem('knobs.wizard.v1') || 'null'); } catch (e) {}
    if (!prog || !prog.answers || !Object.keys(prog.answers).length) return;

    var flat = answersFlat(a);
    var key = JSON.stringify(flat);
    try {
      var last = JSON.parse(localStorage.getItem('kw.notified.v1') || 'null');
      if (last && last.key === key && (Date.now() - last.ts) < 6 * 3600 * 1000) return;
      localStorage.setItem('kw.notified.v1', JSON.stringify({ key: key, ts: Date.now() }));
    } catch (e) {}

    kwJourneyTs = Date.now();
    try {
      localStorage.setItem('kw.journey.v2', JSON.stringify({
        ts: kwJourneyTs,
        answers: flat,
        actions: [],
        result_count: null,
        results_url: window.location.origin + window.location.pathname + window.location.search,
        sent: false
      }));
    } catch (e) { return; }
    // knobs-journey.js (theme-wide) arms the 5-min timer + pagehide sender;
    // it loads before this script, so (re)init it against the fresh record.
    if (window.KWJourney && window.KWJourney.init) window.KWJourney.init();
  }

  /* ── Build the feed URL: collection handle + finish tag-path ────────
     Style is filtered CLIENT-SIDE (not in the path) because the multi-value
     "modern-contemporary" bucket needs an OR across two tags, which the
     AND-only legacy tag-path can't express — putting only one tag in the path
     silently dropped the other (the "1 result" bug). Finish is single-valued,
     so it stays in the path to keep the candidate set tight. */
  function feedUrl(handle, answers, page) {
    var base = '/collections/' + handle;
    if (answers.finish && FINISH_TAG[answers.finish]) {
      base += '/' + FINISH_TAG[answers.finish];
    }
    // Cache-buster: Shopify's per-edge full-page cache can serve a stale HTML
    // render of the collection path and ignore ?view=, returning the normal
    // page instead of our JSON feed. A unique param per page-load forces a
    // fresh render of the wizard-feed view template.
    // Fresh cache-buster EVERY call: Shopify's per-edge full-page cache on
    // /collections/ URLs intermittently serves a stale HTML render and ignores
    // a repeated buster, so a unique value per attempt maximizes cache misses
    // (origin renders our JSON feed view). NOTE: never append preview_theme_id
    // — it 404s on the /collections/all/<tags> route. The feed view template is
    // deployed to the live (main) theme so this resolves natively.
    var cb = String(Date.now()) + Math.floor(Math.random() * 1e6);
    return base + '?view=wizard-feed&page=' + page + '&cb=' + cb;
  }

  /* ── Client-side filters ────────────────────────────────────────── */
  function typeMatches(productType, selectedBuckets) {
    if (!selectedBuckets.length || selectedBuckets.indexOf('other') >= 0) return true;
    var t = (productType || '').toLowerCase();
    for (var i = 0; i < selectedBuckets.length; i++) {
      var b = selectedBuckets[i];
      if (b === 'knobs' && t.indexOf('knob') >= 0 && t.indexOf('backplate') < 0) return true;
      if (b === 'pulls' && t.indexOf('pull') >= 0 && t.indexOf('appliance') < 0 && t.indexOf('backplate') < 0) return true;
      if (b === 'appliance-pulls' && t.indexOf('appliance') >= 0) return true;
      if (b === 'hinges' && t.indexOf('hinge') >= 0) return true;
      if (b === 'backplates' && t.indexOf('backplate') >= 0) return true;
      if (b === 'accessories' && (t.indexOf('accessor') >= 0 || t.indexOf('catch') >= 0 || t.indexOf('latch') >= 0 || t.indexOf('feet') >= 0 || t.indexOf('leg') >= 0)) return true;
    }
    return false;
  }

  // Style refinement for multi-value buckets (modern OR contemporary), since
  // only one variant could ride the server tag-path.
  function styleMatches(tags, styleKey) {
    if (!styleKey || !STYLE_TAG[styleKey]) return true;
    var wanted = STYLE_TAG[styleKey];           // e.g. ['style-modern','style-contemporary']
    var names = wanted.map(function (h) { return h.replace('style-', ''); });
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      if (t.indexOf('Style:') === 0) {
        var val = t.split(':')[1].trim().toLowerCase();
        if (names.indexOf(val) >= 0) return true;
      }
    }
    // Fail-open if the product carries no Style tag at all (24% of catalog).
    return !tags.some(function (t) { return t.indexOf('Style:') === 0; });
  }

  // Drill buckets in millimetres. We match against the SPECIFIC center-to-center
  // value (details.drill_centers, e.g. "12'' (305 mm)") — not the coarse
  // "Larger than 8''" range, which lumps a 9" regular pull with an 18" appliance
  // pull. Regular-pull buckets are inch ranges; appliance buckets (appl-*) are
  // the real size clusters from the catalog (12" and 18" dominate).
  var DRILL_RANGES_MM = {
    'under-3': [0, 75], '3-5': [76, 129], '5-8': [130, 205], 'over-8': [206, 999999],
    'appl-le8': [0, 210], 'appl-10-12': [211, 330], 'appl-13-15': [331, 420],
    'appl-16-18': [421, 485], 'appl-over-18': [486, 999999]
  };
  function drillCentersMM(p) {
    var s = (p && p.drill_centers) ? String(p.drill_centers) : '';
    if (!s) return null;
    var m = s.match(/\((\d+)\s*mm\)/i);            // prefer the "(305 mm)" part
    if (m) return parseInt(m[1], 10);
    var inch = s.match(/^\s*(\d+)(?:\s+(\d+)\/(\d+))?/); // fallback: leading inches
    if (inch) {
      var whole = parseInt(inch[1], 10);
      var frac = inch[2] ? (parseInt(inch[2], 10) / parseInt(inch[3], 10)) : 0;
      return Math.round((whole + frac) * 25.4);
    }
    return null;
  }
  function drillMatches(p, bucket) {
    if (!bucket) return true;
    var r = DRILL_RANGES_MM[bucket];
    if (!r) return true;
    var mm = drillCentersMM(p);
    if (mm == null) return true;                   // fail-open: no specific value
    return mm >= r[0] && mm <= r[1];
  }

  function speedClass(p) {
    if (MTO_VENDORS[p.vendor]) return 'custom';
    var dd = p.delivery_days || '';
    var nums = (dd.match(/\d+/g) || []).map(Number);
    var upper = nums.length ? Math.max.apply(null, nums) : null;
    if (upper !== null && upper <= 6) return 'fast';
    return 'other';                                // in-stock but slower, or unknown
  }
  function speedMatches(p, speed) {
    if (!speed || speed === 'flexible') return true;
    var c = speedClass(p);
    if (speed === 'fast') return c === 'fast';
    if (speed === 'custom') return c === 'custom';
    return true;
  }

  /* ── Budget tiers (RELATIVE to each category) ───────────────────────
     "Mid-range" means different dollars for a knob vs a pull, so the tiers are
     the price tertiles WITHIN each product category (computed from the catalog),
     not a fixed price. A $16 knob and a $20 pull are both "mid." Thresholds are
     [p33, p66] in cents. */
  var TIER_THRESHOLDS = {
    knobs:             [1100, 2900],
    pulls:             [1600, 2600],
    'appliance-pulls': [15000, 21500],
    backplates:        [1300, 2200],
    hinges:            [900, 1400],
    other:             [1500, 3500]
  };
  function priceTierBucket(type) {
    var t = (type || '').toLowerCase();
    if (t.indexOf('appliance') >= 0) return 'appliance-pulls';
    if (t.indexOf('backplate') >= 0) return 'backplates';   // before knob/pull ("Knob/Pull Backplates")
    if (t.indexOf('hinge') >= 0) return 'hinges';
    if (t.indexOf('knob') >= 0) return 'knobs';
    if (t.indexOf('pull') >= 0) return 'pulls';
    return 'other';
  }
  function budgetMatches(p, budget) {
    if (!budget) return true;
    var th = TIER_THRESHOLDS[priceTierBucket(p.type)] || TIER_THRESHOLDS.other;
    var price = p.price || 0;
    if (budget === 'value')  return price <= th[0];
    if (budget === 'luxury') return price > th[1];
    if (budget === 'mid')    return price > th[0] && price <= th[1];
    return true;
  }

  /* ── Family dedup — faithful JS port of snippets/knobs-sku-root.liquid ─ */
  function skuRoot(sku) {
    sku = sku || '';
    var parts = sku.split('-');
    var np = parts.length;
    if (np < 1 || !sku) return '';
    var last = parts[np - 1];
    var lastSize = last.length;
    var rootLast = last, dropLast = false;
    for (var n = 1; n <= 5; n++) {
      var keepN = lastSize - n;
      if (keepN < 0) break;
      var tail = last.slice(keepN, keepN + n);
      var tailUp = tail.toUpperCase(), tailDown = tail.toLowerCase();
      if (tail === tailUp && tail !== tailDown) {  // all-uppercase AND has a letter
        if (keepN === 0) { dropLast = true; rootLast = ''; break; }
        var candidate = last.slice(0, keepN);
        var lastCh = candidate.slice(-1);
        if ('0123456789'.indexOf(lastCh) >= 0) rootLast = candidate;
        if (rootLast !== last) break;
      }
    }
    if (dropLast) {
      var nKeep = np - 1;
      return nKeep <= 0 ? '' : parts.slice(0, nKeep).join('-');
    }
    var nKeep2 = np - 1;
    return nKeep2 <= 0 ? rootLast : parts.slice(0, nKeep2).join('-') + '-' + rootLast;
  }

  function dedupeFamilies(products) {
    var groups = {}, order = [];
    products.forEach(function (p) {
      var r = skuRoot(p.sku);
      // A valid family root must contain a digit (model numbers always do:
      // TK760, M1119, A903). Roots that reduce to a bare brand prefix (TPK,
      // ATL, CNH) over-collapse unrelated products, so treat those as solo.
      var key = (r && /[0-9]/.test(r)) ? r : ('__solo__' + p.id);
      if (!groups[key]) { groups[key] = []; order.push(key); }
      groups[key].push(p);
    });
    return order.map(function (key) {
      var members = groups[key];
      // Lead = prefer available + has image, then image, then available, then first.
      var lead = members.slice().sort(function (a, b) {
        var sa = (a.available ? 2 : 0) + (a.image ? 1 : 0);
        var sb = (b.available ? 2 : 0) + (b.image ? 1 : 0);
        return sb - sa;
      })[0];
      return { lead: lead, moreFinishes: members.length - 1 };
    });
  }

  /* ── Visual-family merge ─────────────────────────────────────────
     SKU-root dedup still leaves a wall of near-identical cards: size runs of
     the same model carry DIFFERENT model numbers (Berenson Advantage Wire
     6150/6152/6153… = the same pull in 3"/3.5"/4"), so 8 of 12 results can be
     one visual product. Merge sku-families whose vendor + de-sized,
     de-finished title match, and surface the count as "more options". */
  function visualKey(p) {
    var t = (p.title || '').toLowerCase();
    t = t
      .replace(/\d+\s+\d+\s*\/\s*\d+/g, ' ')                 // mixed fractions: 3 1/2
      .replace(/\d+\s*\/\s*\d+/g, ' ')                       // bare fractions: 1/2
      .replace(/\d+(\.\d+)?\s*(inches|inch|in\b|mm\b|cm\b|''|")/g, ' ')
      .replace(/\b\d+(\.\d+)?\b/g, ' ')                      // any remaining number (sizes, model #s)
      .replace(/\bcc\b|\bc-c\b|\bcenter to center\b|\bcenters?\b/g, ' ')
      .replace(/\b(polished|satin|brushed|matte|antique|oil[- ]?rubbed|venetian|flat|honed|distressed|weathered|vintage|burnished)\b/g, ' ')
      .replace(/[^a-z]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    return (p.vendor || '') + '|' + t;
  }
  function mergeVisualFamilies(fams) {
    var groups = {}, order = [];
    fams.forEach(function (f) {
      var key = visualKey(f.lead);
      if (!key.split('|')[1]) key = '__solo__' + f.lead.id;   // empty title residue → keep solo
      if (!groups[key]) { groups[key] = []; order.push(key); }
      groups[key].push(f);
    });
    return order.map(function (key) {
      var members = groups[key];
      // Lead = highest boost, then available + has image (keeps the best
      // product's photo/price as the family's face).
      var lead = members.slice().sort(function (a, b) { return leadByBoost(a.lead, b.lead); })[0].lead;
      var moreOptions = members.reduce(function (n, f) { return n + f.moreFinishes + 1; }, 0) - 1;
      return { lead: lead, moreFinishes: moreOptions };
    });
  }

  /* ── Diverse selection ───────────────────────────────────────────
     Keep the top-N grid from reading as one brand's catalog page:
     (a) round-robin across the product types the user actually picked
         (knobs AND pulls selected → both appear), and
     (b) cap families per vendor — relaxed, then dropped, if the pool is
         too small to fill the target under the cap. */
  function displayType(p) {
    var t = (p.type || '').toLowerCase();
    if (t.indexOf('appliance') >= 0) return 'appliance-pulls';
    if (t.indexOf('knob') >= 0 && t.indexOf('backplate') < 0) return 'knobs';
    if (t.indexOf('pull') >= 0 && t.indexOf('backplate') < 0) return 'pulls';
    return 'other';
  }
  function selectDiverse(fams, target, types) {
    var MAX_PER_VENDOR = 3;
    var interleave = types && types.length > 1;
    var buckets, bucketOrder;
    if (interleave) {
      buckets = {}; bucketOrder = [];
      fams.forEach(function (f) {
        var k = displayType(f.lead);
        if (!buckets[k]) { buckets[k] = []; bucketOrder.push(k); }
        buckets[k].push(f);
      });
    } else {
      buckets = { all: fams }; bucketOrder = ['all'];
    }
    function pick(cap) {
      var picked = [], perVendor = {}, used = {};
      var cursors = {};
      bucketOrder.forEach(function (k) { cursors[k] = 0; });
      var progressed = true;
      while (picked.length < target && progressed) {
        progressed = false;
        for (var b = 0; b < bucketOrder.length && picked.length < target; b++) {
          var k = bucketOrder[b], arr = buckets[k];
          while (cursors[k] < arr.length) {
            var f = arr[cursors[k]++];
            var id = f.lead.id;
            var vendor = f.lead.vendor || '';
            if (used[id]) continue;
            if (cap && (perVendor[vendor] || 0) >= cap) continue;
            used[id] = 1;
            perVendor[vendor] = (perVendor[vendor] || 0) + 1;
            picked.push(f);
            progressed = true;
            break;
          }
        }
      }
      return picked;
    }
    var out = pick(MAX_PER_VENDOR);
    if (out.length < target && out.length < fams.length) {
      // Pool too thin for the cap: keep the diverse capped picks first, then
      // top up beyond the cap (instead of re-picking uncapped, which lets one
      // vendor flood the grid again).
      var usedIds = {};
      out.forEach(function (f) { usedIds[f.lead.id] = 1; });
      for (var i = 0; i < fams.length && out.length < target; i++) {
        var f = fams[i];
        if (!usedIds[f.lead.id]) { usedIds[f.lead.id] = 1; out.push(f); }
      }
    }
    return out;
  }

  /* ── Money ──────────────────────────────────────────────────────── */
  var fmt;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); } catch (e) { fmt = null; }
  function money(cents) {
    var d = (cents || 0) / 100;
    return fmt ? fmt.format(d) : ('$' + d.toFixed(2));
  }

  /* ── Rendering ──────────────────────────────────────────────────── */
  function speedBadge(p) {
    var c = speedClass(p);
    if (c === 'custom') return '<span class="kw-rcard__ship kw-rcard__ship--mto">Made to order</span>';
    var dd = (p.delivery_days || '').replace(/business days/i, 'days');
    if (c === 'fast' && dd) return '<span class="kw-rcard__ship kw-rcard__ship--fast">Ships fast · ' + esc(dd) + '</span>';
    return '';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m];
    });
  }
  function cleanTitle(t) {
    return esc(t || 'View product');
  }

  function renderCard(fam) {
    var p = fam.lead;
    var img = p.image
      ? '<img class="kw-rcard__img" src="' + esc(p.image) + '" alt="' + cleanTitle(p.title) + '" loading="lazy">'
      : '<div class="kw-rcard__img kw-rcard__img--placeholder" aria-hidden="true"></div>';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var price = '<span class="kw-rcard__price">' + money(p.price) + '</span>';
    if (onSale) price = '<span class="kw-rcard__price kw-rcard__price--sale">' + money(p.price) + '</span>' +
                        '<span class="kw-rcard__price-was">' + money(p.compare_at_price) + '</span>';
    var more = fam.moreFinishes > 0
      ? '<span class="kw-rcard__more">+' + fam.moreFinishes + ' more option' + (fam.moreFinishes > 1 ? 's' : '') + '</span>'
      : '';
    return '<a class="kw-rcard" href="' + esc(p.url) + '">' +
      '<span class="kw-rcard__media">' + img + '</span>' +
      '<span class="kw-rcard__body">' +
        '<span class="kw-rcard__vendor">' + esc(p.vendor) + '</span>' +
        '<span class="kw-rcard__title">' + cleanTitle(p.title) + '</span>' +
        '<span class="kw-rcard__meta">' + price + more + '</span>' +
        speedBadge(p) +
      '</span>' +
    '</a>';
  }

  function buildNarrative(a, count) {
    var bits = [];
    if (a.style && STYLE_LABEL[a.style]) bits.push(STYLE_LABEL[a.style]);
    if (a.finishSpecific) bits.push(a.finishSpecific);
    else if (a.finish) bits.push(a.finish.charAt(0).toUpperCase() + a.finish.slice(1));
    var BUDGET_LABEL = { value: 'Budget-friendly', mid: 'Mid-range', luxury: 'High-end' };
    if (a.budget && BUDGET_LABEL[a.budget]) bits.push(BUDGET_LABEL[a.budget]);
    if (a.types.length) bits.push(a.types.map(function (t) { return TYPE_LABEL[t] || t; }).join(' & '));
    if (!bits.length) return 'Here ' + (count === 1 ? 'is' : 'are') + ' ' + count + ' great match' + (count === 1 ? '' : 'es') + ' from our catalog.';
    return 'Based on your ' + bits.join(' · ') + ' preferences, here ' + (count === 1 ? 'is' : 'are') + ' ' + count + ' match' + (count === 1 ? '' : 'es') + '.';
  }

  function broadenUrl(a) {
    // Drop the most restrictive axis: finish first, then style.
    var p = new URLSearchParams(window.location.search);
    if (a.finish) { p.delete('finish'); }
    else if (a.style) { p.delete('style'); }
    else if (a.drill) { p.delete('drill'); }
    else if (a.speed && a.speed !== 'flexible') { p.set('speed', 'flexible'); }
    return window.location.pathname + '?' + p.toString();
  }

  /* ── Browse-by-category suggestions ──────────────────────────────
     Handles below are verified-live collection routes; the finish tag-path
     and chip label come from the answers. Lets the "I'd rather browse" visitor
     self-serve and signals catalog depth (a trust cue) before the CTAs. */
  var TYPE_COLLECTION = {
    knobs:             { handle: 'knobs',                                          label: 'Knobs' },
    pulls:             { handle: 'cabinet-pulls',                                  label: 'Pulls' },
    'appliance-pulls': { handle: 'appliance-pulls',                               label: 'Appliance Pulls' },
    hinges:            { handle: 'product-type-cabinet-hardware-hinges',          label: 'Hinges' },
    backplates:        { handle: 'product-type-cabinet-hardware-backplates',      label: 'Backplates' },
    accessories:       { handle: 'product-type-cabinet-hardware-catches-and-latches', label: 'Cabinet Accessories' }
  };
  function suggestionLinks(a) {
    var out = [];
    var finishTag = (a.finish && FINISH_TAG[a.finish]) ? FINISH_TAG[a.finish] : '';
    var finishLabel = a.finish ? (a.finish.charAt(0).toUpperCase() + a.finish.slice(1)) : '';
    var types = a.types.filter(function (t) { return TYPE_COLLECTION[t]; }).slice(0, 3);
    types.forEach(function (t) {
      var c = TYPE_COLLECTION[t];
      out.push({
        href: '/collections/' + c.handle + (finishTag ? '/' + finishTag : ''),
        label: finishLabel ? ('All ' + finishLabel + ' ' + c.label) : ('Shop all ' + c.label)
      });
    });
    if (!out.length && finishTag) {
      out.push({ href: '/collections/all/' + finishTag, label: 'Shop all ' + finishLabel + ' hardware' });
    }
    out.push({ href: '/collections/all', label: 'Browse the full catalog' });
    return out;
  }
  function renderSuggestions(a) {
    if (!suggestedEl || !suggestedChipsEl) return;
    var links = suggestionLinks(a);
    if (!links.length) return;
    suggestedChipsEl.innerHTML = links.map(function (l) {
      return '<a class="kw-chip" href="' + esc(l.href) + '">' + esc(l.label) + '</a>';
    }).join('');
    suggestedEl.hidden = false;
  }

  /* ── Second-layer specific-finish refine (curated classes only) ────
     Chips reload the page with &fin_spec=<exact finish>, which adds a
     meta.details.finish facet filter to the Algolia query and re-renders.
     Only shown for classes in SPECIFIC_FINISHES (Brass first). */
  function renderFinishRefine(a) {
    if (!finishRefineEl) return;
    var specs = a.finish && SPECIFIC_FINISHES[a.finish];
    if (!specs) return;
    function urlWith(spec) {
      var p = new URLSearchParams(window.location.search);
      if (spec) p.set('fin_spec', spec); else p.delete('fin_spec');
      return window.location.pathname + '?' + p.toString();
    }
    var active = a.finishSpecific || '';
    var label = a.finish.charAt(0).toUpperCase() + a.finish.slice(1);
    var chips = ['<a class="kw-chip kw-chip--refine' + (active ? '' : ' is-active') + '" href="' + esc(urlWith('')) + '">Any ' + esc(label) + '</a>'];
    specs.forEach(function (s) {
      chips.push('<a class="kw-chip kw-chip--refine' + (active === s.value ? ' is-active' : '') + '" href="' + esc(urlWith(s.value)) + '">' + esc(s.label) + '</a>');
    });
    finishRefineEl.innerHTML = '<span class="kw-refine__label">Narrow to a specific ' + esc(label.toLowerCase()) + ' finish:</span>' + chips.join('');
    finishRefineEl.hidden = false;
  }

  /* ── Algolia source (boost-ranked) ───────────────────────────────
     The wizard sources candidates from the SAME Algolia index that powers the
     storefront search/collections, so results come back in custom.boost_score
     order (best brands/products first). The old path read /collections/all in
     ALPHABETICAL order and took the first ~480, which let low-boost brands
     dominate (Anne at Home = -5, Alno = 42, vs Top Knobs/Jeffrey Alexander = 442).
     Finish + style are facet filters (AND across axes, OR within style);
     type/drill/speed are applied client-side; families collapse on the curated
     custom.family_key. Public search-only key (same one in knobs-instantsearch.js). */
  var ALGOLIA = { app: 'YQLK7JGQ6E', key: '11defc1b66b77421e9de1469f21f250d', index: 'shopify_products' };
  // Each wizard finish maps to an OR-group of Finish-Class facets so the folded
  // silver-tones (Silver/Steel/Aluminum→Nickel), Brown→Bronze and Clear→Colored
  // still surface under the trimmed picker.
  var FINISH_CLASS_FACETS = {
    nickel:  ['Nickel', 'Silver', 'Steel', 'Aluminum'],
    chrome:  ['Chrome'],
    black:   ['Black'],
    bronze:  ['Bronze', 'Brown'],
    brass:   ['Brass'],
    gold:    ['Gold'],
    copper:  ['Copper'],
    pewter:  ['Pewter'],
    gray:    ['Gray'],
    iron:    ['Iron'],
    colored: ['Colored', 'Clear']
    // 'white' removed from the picker 2026-06-19 (too sparse for knobs/pulls).
  };
  // Optional second-layer "specific finish" refine — curated per class, only for
  // classes where the specific finish is visually decisive. Brass first (values
  // are exact meta.details.finish facet strings). Add Bronze/Black/Nickel later.
  var SPECIFIC_FINISHES = {
    brass: [
      { value: 'Polished Brass',    label: 'Polished' },
      { value: 'Satin Brass',       label: 'Satin / Brushed' },
      { value: 'Antique Brass',     label: 'Antique' },
      { value: 'Unlacquered Brass', label: 'Unlacquered' }
    ]
  };
  var STYLE_ALGOLIA = {
    'modern-contemporary': ['Modern', 'Contemporary'],
    'transitional': ['Transitional'],
    'traditional': ['Traditional']
  };

  function algoliaFacetFilters(a) {
    var groups = [];
    if (a.finish && FINISH_CLASS_FACETS[a.finish]) groups.push(FINISH_CLASS_FACETS[a.finish].map(function (c) { return 'tags:Finish-Class: ' + c; }));
    if (a.style && STYLE_ALGOLIA[a.style]) groups.push(STYLE_ALGOLIA[a.style].map(function (s) { return 'tags:Style: ' + s; }));
    if (a.finishSpecific) groups.push(['meta.details.finish:' + a.finishSpecific]);  // second-layer refine
    return groups;
  }
  function imageUrl(h) {
    var im = h.image || h.product_image;
    if (!im) return null;
    return (typeof im === 'string') ? im : (im.src || im.url || null);
  }
  function drillFromTags(tags) {
    for (var i = 0; i < (tags || []).length; i++) {
      if (tags[i].indexOf('Drill-Centers:') === 0 && tags[i].indexOf('Range') < 0) return tags[i].split(':').slice(1).join(':').trim();
    }
    return '';
  }
  function normalizeHit(h) {
    var meta = h.meta || {}, c = meta.custom || {}, det = meta.details || {};
    var moreFin = 0;
    if (c.family_finishes) { try { var arr = JSON.parse(c.family_finishes); if (arr && arr.length) moreFin = arr.length - 1; } catch (e) {} }
    return {
      id: h.id,
      title: h.title,
      vendor: h.vendor,
      type: h.product_type,
      image: imageUrl(h),
      price: Math.round((h.price || 0) * 100),                 // Algolia price is dollars; cards render cents
      compare_at_price: Math.round((h.compare_at_price || 0) * 100),
      url: h.handle ? ('/products/' + h.handle) : '#',
      sku: h.sku || '',
      tags: h.tags || [],
      available: h.inventory_available !== false,              // reliable flag (variants_inventory_count can read 0 yet sell)
      delivery_days: c.delivery_days || '',
      drill_centers: (det.drill_centers != null ? String(det.drill_centers) : drillFromTags(h.tags)),
      family_key: c.family_key || '',
      family_more: moreFin,
      boost: (c.boost_score != null ? c.boost_score : -9999)
    };
  }
  function fetchAlgolia(a, cb, attempt) {
    attempt = attempt || 1;
    var ff = algoliaFacetFilters(a);
    var attrs = ['id','title','handle','vendor','product_type','image','product_image','price','compare_at_price','sku','tags','inventory_available','meta.custom.boost_score','meta.custom.family_key','meta.custom.family_finishes','meta.custom.delivery_days','meta.details.drill_centers'];
    var params = 'query=&hitsPerPage=600&attributesToRetrieve=' + encodeURIComponent(JSON.stringify(attrs));
    if (ff.length) params += '&facetFilters=' + encodeURIComponent(JSON.stringify(ff));
    fetch('https://' + ALGOLIA.app + '-dsn.algolia.net/1/indexes/' + ALGOLIA.index + '/query', {
      method: 'POST',
      headers: { 'X-Algolia-API-Key': ALGOLIA.key, 'X-Algolia-Application-Id': ALGOLIA.app, 'Content-Type': 'application/json' },
      body: JSON.stringify({ params: params })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (!d || !d.hits) throw new Error('no hits'); cb(d.hits.map(normalizeHit)); })
      .catch(function () {
        if (attempt < 3) return setTimeout(function () { fetchAlgolia(a, cb, attempt + 1); }, 250);
        cb(null);
      });
  }

  /* ── Family dedup (curated custom.family_key) ──────────────────────
     family_key collapses the same model across finishes — far more reliable
     than the old SKU-root guess. Visual-family merge (above) then collapses
     size runs. Lead = highest boost, then available + has image. */
  function leadByBoost(a, b) {
    if ((b.boost || 0) !== (a.boost || 0)) return (b.boost || 0) - (a.boost || 0);
    var sa = (a.available ? 2 : 0) + (a.image ? 1 : 0);
    var sb = (b.available ? 2 : 0) + (b.image ? 1 : 0);
    return sb - sa;
  }
  function dedupeFamilyKey(products) {
    var groups = {}, order = [];
    products.forEach(function (p) {
      var key = p.family_key ? ('fk:' + p.family_key) : ('__solo__' + p.id);
      if (!groups[key]) { groups[key] = []; order.push(key); }
      groups[key].push(p);
    });
    return order.map(function (key) {
      var members = groups[key];
      var lead = members.slice().sort(leadByBoost)[0];
      return { lead: lead, moreFinishes: lead.family_more || (members.length - 1) };
    });
  }

  /* ── Fetch + filter ──────────────────────────────────────────────── */
  // Finish/style are Algolia facets; type/drill/speed are applied client-side.
  var MIN_OK = 4;

  function familiesUnder(core, a, useDrill, useSpeed, useBudget) {
    var filtered = core.filter(function (p) {
      return (!useDrill || drillMatches(p, a.drill))
          && (!useSpeed || speedMatches(p, a.speed))
          && (!useBudget || budgetMatches(p, a.budget));
    });
    var fams = mergeVisualFamilies(dedupeFamilyKey(filtered));
    fams.sort(function (x, y) { return (y.lead.boost || 0) - (x.lead.boost || 0); });  // hold boost order through grouping
    return fams;
  }

  /* ── Concierge form (always visible) ──────────────────────────────
     A "describe what you want" form, pre-filled first-person from the answers
     and fully editable. Submits via Shopify's native contact form → the CS email
     → an Intercom conversation (no backend). */
  function buildConciergeBrief(a) {
    var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; };
    var BUDGET = { value: 'Budget-friendly', mid: 'Mid-range', luxury: 'High-end' };
    var lines = ["Hi Kayla! I'm shopping for the following and would love some expert shopping help:", ''];
    if (a.types && a.types.length) lines.push('• Looking for: ' + a.types.map(function (t) { return TYPE_LABEL[t] || t; }).join(', '));
    if (a.style && STYLE_LABEL[a.style]) lines.push('• Style: ' + STYLE_LABEL[a.style]);
    var fin = a.finishSpecific || (a.finish ? cap(a.finish) : '');
    if (fin) lines.push('• Finish: ' + fin);
    if (a.budget && BUDGET[a.budget]) lines.push('• Budget: ' + BUDGET[a.budget]);
    lines.push('', "Specifically, I'd love help finding: ");
    return lines.join('\n');
  }
  function renderConcierge(a) {
    var form = document.getElementById('kw-concierge-form');
    if (!form) return;
    var body = form.querySelector('[data-concierge-body]');
    if (body && !body.value) body.value = buildConciergeBrief(a);   // editable pre-fill
    // Let Shopify's contact form submit NATIVELY (a fetch to /contact is unreliable —
    // Shopify bot-protects it). Fire the Klaviyo event first, while the answers are
    // still in scope; the ?contact_posted=true reload then shows the confirmation.
    form.addEventListener('submit', function () {
      try { klaviyoPush(['track', 'Concierge Request', { types: a.types.join(', '), style: a.style, finish: a.finish, budget: a.budget, source: 'cabinet-hardware-wizard' }]); } catch (e) {}
    });
  }

  function run() {
    var a = readAnswers();

    // After a concierge submit, Shopify reloads with ?contact_posted=true and the
    // answer params stripped. Show a clean confirmation instead of re-running an
    // answer-less search (which would surface a confusing generic grid).
    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      if (loadingEl && loadingEl.parentNode) loadingEl.parentNode.removeChild(loadingEl);
      if (headingEl) headingEl.textContent = 'Your note is on its way to Kayla';
      if (narrativeEl) narrativeEl.textContent = 'She usually replies within a couple of hours. Meanwhile, feel free to keep browsing.';
      if (gridEl) gridEl.innerHTML = '<div class="kw-results-empty"><p><a href="' + wizardUrl + '">Retake the wizard</a> &nbsp;·&nbsp; <a href="/collections/all">Browse the catalog</a></p></div>';
      return;
    }

    // Branch CTAs (work off URL params regardless of result fetch).
    // The design session (Kayla) is now offered to EVERYONE (Q7 retired). For a
    // trade pro the Trade Pros banner is the PRIMARY next step and renders above
    // a compact secondary "talk to Kayla" line; homeowners get the design session
    // as their primary card and no trade banner.
    // Results CTAs are driven by the "anything you'd like help with?" multi-select.
    // Each checkbox lights up its card; if they checked nothing, the Kayla design
    // session shows as the default destination.
    var I = a.interests || [];
    var wants = function (x) { return I.indexOf(x) >= 0; };
    var isTrade = a.trade === 'trade';

    track('wizard_results_view', answersFlat(a));
    initCompletionNotify(a);

    // Next-step telemetry: every results-page CTA + product-card click lands in
    // GA4 (wizard_cta_click) and in the completion email's "what they did next".
    if (samplesCtaEl) samplesCtaEl.addEventListener('click', function (e) {
      if (e.target.closest('a')) recordAction('samples');
    });
    if (quoteCtaEl) quoteCtaEl.addEventListener('click', function (e) {
      if (e.target.closest('a')) recordAction('quote');
    });
    if (tradeBannerEl) tradeBannerEl.addEventListener('click', function (e) {
      if (e.target.closest('a')) recordAction('trade_program');
    });
    if (broadenLink) broadenLink.addEventListener('click', function () { recordAction('broaden_results'); });
    var conciergeForm = document.getElementById('kw-concierge-form');
    if (conciergeForm) conciergeForm.addEventListener('submit', function () { recordAction('concierge_message'); });
    root.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (link) {
        var handle = (link.getAttribute('href').match(/\/products\/([^/?#]+)/) || [])[1] || '';
        recordAction('product', handle);
      }
    });
    if (consultLink && consultationUrl) consultLink.setAttribute('href', consultationUrl);
    if (isTrade && tradeBannerEl) tradeBannerEl.hidden = false;                              // Trade pricing
    if ((wants('samples') || wants('matching')) && samplesCtaEl) samplesCtaEl.hidden = false; // samples (matching → compare in person)
    if (wants('quote') && quoteCtaEl) quoteCtaEl.hidden = false;                              // bulk quote
    if ((wants('consult') || wants('matching') || I.length === 0) && consultCtaEl) consultCtaEl.hidden = false; // Kayla (default)
    if (consultLink) consultLink.addEventListener('click', function () {
      recordAction('consultation');
      try { klaviyoPush(['track', 'Requested Design Consultation', { types: a.types.join(', '), trade_pro: isTrade, source: 'cabinet-hardware-wizard' }]); } catch (e) {}
    });
    renderSuggestions(a);
    renderFinishRefine(a);
    renderConcierge(a);
    if (emailCaptureEl) emailCaptureEl.hidden = false;
    if (broadenLink) broadenLink.setAttribute('href', broadenUrl(a));

    // Klaviyo funnel events (task #6). These fire on the anonymous/known cookie
    // profile — no email needed; if the visitor later identifies, Klaviyo merges.
    // Build Klaviyo flows/segments on these metrics: "Completed Cabinet Wizard"
    // (all quiz answers as event + later profile props) and "Requested Design
    // Consultation" (the consultation-booking funnel).
    try {
      var ev = {
        types: a.types.join(', '), style: a.style, finish: a.finish,
        drill: a.drill, speed: a.speed, budget: a.budget,
        trade_pro: a.trade === 'trade',
        interests: (a.interests || []).join(', '),
        wants_samples: (a.interests || []).indexOf('samples') >= 0,
        wants_consultation: (a.interests || []).indexOf('consult') >= 0,
        wants_quote: (a.interests || []).indexOf('quote') >= 0,
        source: 'cabinet-hardware-wizard'
      };
      klaviyoPush(['track', 'Completed Cabinet Wizard', ev]);
      // "Requested Design Consultation" now fires on the design-session click
      // (Q7's pre-commit question was retired), not on a quiz answer.
    } catch (e) {}

    // Compute the curated families to show (type filter + drill/speed broaden +
    // dedup + diversity). Pure — no DOM. excl = optional family-key/visual-key set
    // to skip (used so the "other styles" overflow doesn't repeat the main grid).
    function selectShow(core, ans, excl) {
      var typed = core.filter(function (p) { return typeMatches(p.type, ans.types); });
      if (excl) typed = typed.filter(function (p) { return !excl['k' + famKey(p)] && !excl['v' + visualKey(p)]; });
      var note = '';
      var hasDrill = !!ans.drill, hasSpeed = ans.speed && ans.speed !== 'flexible', hasBudget = !!ans.budget;
      var fams = familiesUnder(typed, ans, true, true, true);
      if (fams.length < MIN_OK && hasDrill) {
        var f2 = familiesUnder(typed, ans, false, true, true);
        if (f2.length > fams.length) { fams = f2; note = 'We widened the drill-center range to show more options.'; }
      }
      if (fams.length < MIN_OK && hasSpeed) {
        var f3 = familiesUnder(typed, ans, false, false, true);
        if (f3.length > fams.length) { fams = f3; note = 'We included more lead-time options to show more matches.'; }
      }
      if (fams.length < MIN_OK && hasBudget) {
        var f4 = familiesUnder(typed, ans, false, false, false);
        if (f4.length > fams.length) { fams = f4; note = 'We included other price points to show more matches.'; }
      }
      return { show: selectDiverse(fams, TARGET, ans.types), note: note };
    }
    function famKey(p) { return p.family_key ? ('fk:' + p.family_key) : ('id:' + p.id); }
    function excludeSet(show) {
      var s = {};
      show.forEach(function (f) { s['k' + famKey(f.lead)] = 1; s['v' + visualKey(f.lead)] = 1; });
      return s;
    }

    fetchAlgolia(a, function (core) {
      if (loadingEl && loadingEl.parentNode) loadingEl.parentNode.removeChild(loadingEl);
      if (core === null) {
        gridEl.innerHTML = '<div class="kw-results-empty">' +
          '<p>We had trouble loading your matches just now.</p>' +
          '<p><a href="' + broadenUrl(a) + '">Browse the catalog</a> or <a href="' + wizardUrl + '">start over</a>.</p>' +
          '</div>';
        if (narrativeEl) narrativeEl.textContent = '';
        return;
      }

      // Primary grid = STRICTLY the chosen style (no unstyled mixed in).
      var primary = selectShow(core, a, null);
      var styleLabel = a.style ? (STYLE_LABEL[a.style] || a.style) : '';

      if (primary.show.length) {
        if (narrativeEl) narrativeEl.textContent = buildNarrative(a, primary.show.length) + (primary.note ? '  ' + primary.note : '');
        gridEl.className = 'knobs-wizard-results__grid kw-results-grid';
        gridEl.innerHTML = primary.show.map(renderCard).join('');
        kwResultCount = primary.show.length;
        journeyUpdate(function (j) { j.result_count = primary.show.length; });
        track('wizard_results_loaded', { result_count: primary.show.length });
        if (refineEl) refineEl.hidden = false;
      } else if (a.style) {
        // No in-style matches — the separated "Other styles" section carries it.
        if (narrativeEl) narrativeEl.textContent = 'We didn’t find a close ' + styleLabel + ' match for those preferences — but here are great options in other styles.';
        gridEl.innerHTML = '';
        if (refineEl) refineEl.hidden = false;
      } else {
        gridEl.innerHTML = '<div class="kw-results-empty">' +
          '<p>We couldn’t find a close match for those preferences.</p>' +
          '<p><a href="' + broadenUrl(a) + '">Broaden your results</a> or <a href="' + wizardUrl + '">try different answers</a>.</p>' +
          '</div>';
        if (narrativeEl) narrativeEl.textContent = 'No exact matches — try broadening.';
        kwResultCount = 0;
        journeyUpdate(function (j) { j.result_count = 0; });
        track('wizard_results_loaded', { result_count: 0 });
        return;
      }

      // "Other styles you might like" — only when a style was chosen and we
      // couldn't fill a full in-style grid. A SEPARATE, labelled section (never
      // blended into the main grid): a second query drops the style filter and
      // we exclude whatever the primary grid already showed.
      if (a.style && primary.show.length < TARGET) {
        var a2 = readAnswers(); a2.style = '';
        var excl = excludeSet(primary.show);
        fetchAlgolia(a2, function (core2) {
          if (core2 === null) return;
          var other = selectShow(core2, a2, excl);
          if (!other.show.length) return;
          if (otherTitleEl) otherTitleEl.textContent = primary.show.length
            ? 'Other styles you might like'
            : 'Great options in other styles';
          otherGridEl.className = 'knobs-wizard-results__grid kw-results-grid';
          otherGridEl.innerHTML = other.show.slice(0, TARGET).map(renderCard).join('');
          if (otherStylesEl) otherStylesEl.hidden = false;
        });
      }
    });
  }

  /* ── Email capture → Klaviyo (minimal; task #6 expands) ─────────── */
  function klaviyoPush(t) { try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(t); return true; } catch (e) { return false; } }
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var a = readAnswers();
      var name = (emailForm.elements['name'] && emailForm.elements['name'].value || '').trim();
      var email = (emailForm.elements['email'] && emailForm.elements['email'].value || '').trim();
      if (!email) return;
      klaviyoPush(['identify', {
        '$email': email,
        '$first_name': name,
        'wizard_completed': true,
        'wizard_types': a.types.join(', '),
        'wizard_style': a.style,
        'wizard_finish': a.finish,
        'wizard_drill_centers': a.drill,
        'wizard_lead_time_pref': a.speed,
        'wizard_consultation_interest': a.consult === 'yes',
        'wizard_trade_pro': a.trade === 'trade',
        'wizard_source': 'cabinet-hardware-wizard'
      }]);
      klaviyoPush(['track', 'Saved Wizard Results', {
        email: email, types: a.types.join(', '), style: a.style, finish: a.finish,
        speed: a.speed, source: 'cabinet-hardware-wizard'
      }]);
      emailCaptureEl.innerHTML = '<p class="kw-email-thanks">Thanks, ' + esc(name || 'we’ve got it') + '! We’ve saved your results and will be in touch.</p>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
